(function(){
'use strict';

/* ============================================================
   DESKTOP: savvy-shopall-menu (3-panel dropdown)
   ============================================================ */
var menu = document.getElementById('savvy-shopall-menu');
if(menu){
  var isOpen = false;
  function openMenu(){ menu.setAttribute('aria-hidden','false'); isOpen = true; }
  function closeMenu(){ menu.setAttribute('aria-hidden','true'); isOpen = false; }
  function toggleMenu(e){ e.preventDefault(); e.stopPropagation(); if(isOpen){ closeMenu(); } else { openMenu(); } }
  function switchTab(activeTab){
    var tabId = activeTab.getAttribute('data-shopall-tab');
    menu.querySelectorAll('[data-shopall-tab]').forEach(function(t){
      var a = t === activeTab;
      t.classList.toggle('savvy-shopall__tab--activo', a);
      t.setAttribute('aria-selected', a ? 'true' : 'false');
    });
    menu.querySelectorAll('[role="tabpanel"]').forEach(function(p){
      var a = p.id === 'savvy-panel-' + tabId;
      p.classList.toggle('savvy-shopall__subpanel--activo', a);
      if(a){ p.removeAttribute('hidden'); } else { p.setAttribute('hidden',''); }
    });
  }
  document.querySelectorAll('[data-shopall-trigger]').forEach(function(b){ b.addEventListener('click', toggleMenu); });
  var fondo = menu.querySelector('[data-shopall-fondo]');
  var closeBtn = menu.querySelector('[data-shopall-close]');
  if(fondo) fondo.addEventListener('click', closeMenu);
  if(closeBtn) closeBtn.addEventListener('click', closeMenu);
  menu.querySelectorAll('[data-shopall-tab]').forEach(function(tab){
    tab.addEventListener('click', function(){ switchTab(tab); });
    if(window.innerWidth >= 750){ tab.addEventListener('mouseenter', function(){ switchTab(tab); }); }
  });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && isOpen) closeMenu(); });
  document.addEventListener('click', function(e){
    if(!isOpen || window.innerWidth < 750) return;
    var trig = document.querySelector('[data-shopall-trigger]');
    if(!menu.contains(e.target) && !(trig && trig.contains(e.target))){ closeMenu(); }
  });
}

/* ============================================================
   MOBILE: Shop All fullscreen overlay
   Strategy: Clone the panel content from inside the <details>
   to a new div appended directly on <body>.
   This escapes sticky-header's containing block so
   position:fixed works correctly.
   
   INIT ALWAYS (not gated by innerWidth) — CSS handles
   show/hide via media queries. This way the overlay is
   ready whether the page loads on mobile or desktop.
   ============================================================ */
var det = document.getElementById('savvy-shopall-mobile-details');
var srcPanel = det ? det.querySelector('.savvy-shopall-mobile-panel') : null;

if(det && srcPanel){
  /* Create overlay container on <body> */
  var overlay = document.createElement('div');
  overlay.className = 'savvy-shopall-mobile-overlay';
  overlay.innerHTML = srcPanel.innerHTML;
  document.body.appendChild(overlay);

  /* Wire up close button inside the overlay */
  var cerrarBtn = overlay.querySelector('.savvy-shopall-mobile-panel__cerrar');
  if(cerrarBtn){
    cerrarBtn.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      closeMobileMenu();
    });
  }

  /* Also wire up any element with data-shopall-mobile-close */
  overlay.querySelectorAll('[data-shopall-mobile-close]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      closeMobileMenu();
    });
  });

  function openMobileMenu(){
    overlay.classList.add('savvy-shopall-mobile-overlay--activo');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu(){
    overlay.classList.remove('savvy-shopall-mobile-overlay--activo');
    document.body.style.overflow = '';
  }

  /* Intercept the <details> toggle — prevent native open, use our overlay instead */
  det.addEventListener('click', function(e){
    var summary = e.target.closest('summary');
    if(summary && det.contains(summary)){
      e.preventDefault();
      if(overlay.classList.contains('savvy-shopall-mobile-overlay--activo')){
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    }
  });

  /* Escape key */
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && overlay.classList.contains('savvy-shopall-mobile-overlay--activo')){
      closeMobileMenu();
    }
  });

  /* Tap outside overlay content to close */
  overlay.addEventListener('click', function(e){
    if(e.target === overlay){
      closeMobileMenu();
    }
  });
}

})();
